import { useCallback, useRef } from 'react';
import { isProd } from '../utils/env-util.js';

function useGtag() {
  const trackEvent = useCallback((eventName, eventParams) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, eventParams);
    } else {
      console.warn(
        'gtag is not initialized. Event not tracked:',
        eventName,
        eventParams
      );
    }
  }, []);

  const firedEvents = useRef(new Set());

  function trackEventOnce(eventName, eventParams = {}, force = false) {
    if (!isProd() && !force) {
      console.log(`Skipping event (not prod): ${eventName}`, eventParams);
      return;
    }

    if (firedEvents.current.has(eventName)) {
      console.log(`Already tracked: ${eventName}`, eventParams);
      return;
    }

    firedEvents.current.add(eventName);
    trackEvent(eventName, eventParams);
  }

  return { trackEvent, trackEventOnce };
}

export default useGtag;
